import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import env from './config/env'
import './index.css'

// Log app info in development
if (env.enableDebug) {
  console.log(`${env.appName} v${env.appVersion}`)
  console.log(`Environment: ${env.isProduction ? 'production' : 'development'}`)
  console.log(`API URL: ${env.apiUrl}`)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
